import React, { useState, useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';

function PregnancyDetailsForm() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    patientId: '',
    startDate: '',
    expectedDelivery: '',
    gravida: '',
    para: '',
    highRisk: false,
    complications: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateField = (name, value) => {
    if(name === 'startDate'){name = "Start Date";}
    if (!value) return `${name} is required`;
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(formData).forEach(key => {
      if (key !== 'highRisk' && key !== 'complications' && key !== 'expectedDelivery') {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      await handleAPICall({
        ...formData,
        apiType: 'pregnancyDetails'
      });
    } catch (error) {
      console.error('Submission error:', error);
    }
    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded-3 shadow bg-white mt-5">
      <h2 className="mb-2 text-primary fw-bold">Pregnancy Details</h2>

      <div className="row mb-2 g-3">
        <div className="col-md-12">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Patient *</label>
            <select
              name="patientId"
              value={formData.patientId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.patientId ? 'is-invalid' : ''}`}
            >
              <option value="">Select Patient</option>
              {/* Map through patients here */}
            </select>
            {errors.patientId && <div className="invalid-feedback">{errors.patientId}</div>}
          </div>
        </div>
      </div>

      <div className="row mb-2 g-3">
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Start Date *</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.startDate ? 'is-invalid' : ''}`}
            />
            {errors.startDate && <div className="invalid-feedback">{errors.startDate}</div>}
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Expected Delivery</label>
            <input
              type="date"
              name="expectedDelivery"
              value={formData.expectedDelivery}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2"
            />
          </div>
        </div>
      </div>

      <div className="row mb-2 g-3">
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Gravida *</label>
            <input
              type="number"
              name="gravida"
              value={formData.gravida}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.gravida ? 'is-invalid' : ''}`}
              min="0"
            />
            {errors.gravida && <div className="invalid-feedback">{errors.gravida}</div>}
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Para *</label>
            <input
              type="number"
              name="para"
              value={formData.para}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.para ? 'is-invalid' : ''}`}
              min="0"
            />
            {errors.para && <div className="invalid-feedback">{errors.para}</div>}
          </div>
        </div>
        <div className="col-md-12 d-flex align-items-end">
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input me-2"
              id="highRisk"
              name="highRisk"
              checked={formData.highRisk}
              onChange={handleChange}
            />
            <label className="form-check-label text-secondary" htmlFor="highRisk">
              High Risk Pregnancy
            </label>
          </div>
        </div>
      </div>

      <div className="row mb-1">
        <div className="col-md-12">
          <div className="mb-1">
            <label className="form-label fw-medium text-secondary">Complications</label>
            <textarea
              name="complications"
              value={formData.complications}
              onChange={handleChange}
              className="form-control border-light"
              rows="3"
              placeholder="Enter any complications..."
            ></textarea>
          </div>
        </div>
      </div>

      <div className="d-grid mt-1">
        <button
          type="submit"
          className="btn btn-primary btn-lg fw-medium w-100"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Save Pregnancy Details'}
        </button>
      </div>
    </form>
  );
}

export default PregnancyDetailsForm;